"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Union_1 = require("../Union");
const union_1 = __importDefault(require("../Union/union"));
const _internals_1 = require("../_internals");
const Defs = {
    trivials: ["Merge"],
    identities: ["Empty"],
    zero: "Empty",
    resolve: ["Merge"],
    reject: ["Empty"],
    overrides: {
        concat: {
            Merge(m) {
                return Merge.from((0, _internals_1.merge)(this.get(), m.get()));
            },
        },
        toPromise: {
            Merge: _internals_1.monoidToPromise,
            Empty: _internals_1.monoidToPromise,
        },
        toThenable: {
            Merge: _internals_1.monoidThen,
            Empty: _internals_1.monoidThen,
        }
    },
};
function defaultConstructor(x) {
    return (0, _internals_1.equals)({}, x) ? this.Empty() : this.Merge(x);
}
const Merge = (0, union_1.default)("Merge", {
    Merge: (x) => x,
    Empty: () => ({}),
}, [
    (0, Union_1.Eq)({
        trivials: ["Merge", "Empty"],
        empties: [],
    }),
    (0, Union_1.Functor)(Defs),
    (0, Union_1.Semigroup)(Defs),
    (0, Union_1.Monoid)(Defs),
    (0, Union_1.Thenable)(Defs),
    (0, Union_1.Show)(Defs),
]).constructors({
    of: defaultConstructor,
    from: defaultConstructor,
});
exports.default = Merge;
